import {createContext, useContext} from 'react';

const TableContext = createContext({cellAlign: 'left'});

export const useTableContext = () => useContext(TableContext);

export default TableContext;
